import { css } from 'glamor';

export const container = css({
  paddingBottom: 10,
}).toString();

export const items = {
  margin: '0 8px',
  height: '100%',
};
